var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0.625C47.7988 0.625 61.5 14.3262 61.5 31.125C61.5 48.043 47.7988 61.625 31 61.625C14.082 61.625 0.5 48.043 0.5 31.125C0.5 14.3262 14.082 0.625 31 0.625ZM31 55.9062C44.582 55.9062 55.7812 44.8262 55.7812 31.125C55.7812 17.543 44.582 6.34375 31 6.34375C17.2988 6.34375 6.21875 17.543 6.21875 31.125C6.21875 44.8262 17.2988 55.9062 31 55.9062ZM31 36.8438C29.332 36.8438 28.1406 35.6523 28.1406 33.9844V18.7344C28.1406 17.1855 29.332 15.875 31 15.875C32.5488 15.875 33.8594 17.1855 33.8594 18.7344V33.9844C33.8594 35.6523 32.5488 36.8438 31 36.8438ZM31 40.8945C33.0254 40.8945 34.6934 42.5625 34.6934 44.5879C34.6934 46.6133 33.0254 48.2812 31 48.2812C28.8555 48.2812 27.1875 46.6133 27.1875 44.5879C27.1875 42.5625 28.8555 40.8945 31 40.8945Z",
    fill: "#DF2935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamation);
export default __webpack_public_path__ + "static/media/circle-exclamation.d6b8f2e64a7e6eda5d3a5981e7dcb15e.svg";
export { ForwardRef as ReactComponent };